/**
 * @generated SignedSource<<8c47322fb9e84eff12e1d8eacbb04f7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type columnPicker_issueViewChildIssuesPanel$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer307BadPattern">;
  readonly " $fragmentType": "columnPicker_issueViewChildIssuesPanel";
};
export type columnPicker_issueViewChildIssuesPanel$key = {
  readonly " $data"?: columnPicker_issueViewChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "columnPicker_issueViewChildIssuesPanel",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer307BadPattern"
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "b52a36f5c2a874b3f47972f17f6900df";

export default node;
